import { v4 as uuidv4 } from 'uuid';

import { DynamicField } from '~/interfaces/DynamicField';
import { DynamicFieldResponse } from '~/interfaces/DynamicFieldResponse';
import { FinalReportData } from '~/interfaces/FinalReportData';

export const transformToDynamicFieldResponse = (
  values: FinalReportData | null,
): DynamicFieldResponse[] | undefined => {
  if (!values) return undefined;
  return values.final_report_custom_field_values.map((field) => {
    const siblingFields: DynamicFieldResponse[] = field.siblings.map(
      (sibling) => {
        return {
          id: sibling.id,
          placeholder: sibling.final_report_custom_field_sibling.placeholder,
          label: sibling.final_report_custom_field_sibling.label,
          dropdown_choices:
            sibling.final_report_custom_field_sibling.dropdown_choices,
          is_mandatory: sibling.final_report_custom_field_sibling.is_mandatory,
          type: sibling.final_report_custom_field_sibling.type,
          value: sibling.value,
          report_template: sibling.final_report_custom_field_sibling.id,
        };
      },
    );

    return {
      id: field.id,
      placeholder: field.final_report_custom_field.placeholder,
      label: field.final_report_custom_field.label,
      dropdown_choices: field.final_report_custom_field.dropdown_choices,
      is_mandatory: field.final_report_custom_field.is_mandatory,
      type: field.final_report_custom_field.type,
      value: field.value,
      siblings: siblingFields,
      report_template: field.final_report_custom_field.id,
    };
  });
};

export const transformToDynamicField = (
  values: DynamicFieldResponse[] | undefined,
): DynamicField[] | undefined => {
  if (!values) return undefined;
  return values.map((field) => {
    const fieldSiblings = field.siblings?.map((sibling) => {
      return {
        id: sibling.id,
        fieldId: uuidv4(),
        type: sibling.type,
        value: sibling.value ?? sibling.placeholder ?? '',
        fieldTitle: sibling.label,
        placeholder: sibling.placeholder ?? '',
        isMandatory: sibling.is_mandatory,
        dropdownItems: sibling.dropdown_choices,
      };
    });

    const parentField: DynamicField = {
      id: field.id,
      fieldId: uuidv4(),
      type: field.type,
      value: field.value ?? field.placeholder ?? '',
      fieldTitle: field.label,
      placeholder: field.placeholder ?? '',
      isMandatory: field.is_mandatory,
      dropdownItems: field.dropdown_choices,
      siblings: fieldSiblings,
    };

    return parentField;
  });
};
